import { Injectable } from '@angular/core';
import { ScriptLoaderService } from './script-loader.service';
import { environment } from '@environments/environment';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root'
})
export class CookieManagerService {
  constructor(private scriptLoader: ScriptLoaderService, private logger: LoggingService) {
    this.loadOneTrustScripts();
  }

  private loadScript(id: string, src: string | null, dataAttributes?: { [key: string]: string }) {
    if (!src) return;
    return this.scriptLoader.load({ id, src, loaded: false, async: true, dataAttributes });
  }
  private loadOneTrustScripts() {
    const { autoBlockSrc, mainSrc, domainAttribute } = environment.oneTrust;
    if (autoBlockSrc) {
      this.loadScript('onetrust-test-script', autoBlockSrc)?.subscribe(
        () => this.loadMainScript(mainSrc, domainAttribute),
        (error) => this.logger.logError(error)
      );
    } else {
      this.loadMainScript(mainSrc, domainAttribute);
    }
  }
  private loadMainScript(mainSrc: string, domainAttribute: string) {
    this.loadScript('onetrust-main-script', mainSrc, { 'domain-script': domainAttribute })?.subscribe(
      () => this.logger.log('OneTrust scripts loaded'),
      (error) => this.logger.logError(error)
    );
  }
  reloadOTBanner() {
    var otConsentSdk = document.getElementById("onetrust-consent-sdk");
    if (otConsentSdk) {
      otConsentSdk.remove();
    }

    if ((window as any).OneTrust != null) {
      (window as any).OneTrust.Init();
      setTimeout(function () {
        (window as any).OneTrust.LoadBanner();
        var toggleDisplay = document.getElementsByClassName("ot-sdk-show-settings");
        for (var i = 0; i < toggleDisplay.length; i++) {
          (toggleDisplay[i] as HTMLElement).onclick = function (event) {
            event.stopImmediatePropagation();
            (window as any).OneTrust.ToggleInfoDisplay();
          };
        }
      }, 1000);
    }
  }
}
